


















import { Component, Vue } from "vue-property-decorator";
import ModalContainer from "@app/shared/modals/main.vue";

@Component({
    components: {
        ModalContainer
    }
})
export default class LayoutOneColumn extends Vue {

}
